import { AccountTypeEnum } from 'api-hooks/transactions/transfer';
import HOCInput from 'components/common/hoc-input';
import { Input } from 'components/elements';
import Text from 'components/elements/text';
import {
  FullContainer,
  HalfContainer,
  SeparatorVertical,
} from 'components/styles';
import BankAccountSelectInput from 'legacy-modules/master/bank-account/components/select-input';
import CashAccountSelectInput from 'legacy-modules/master/cash-account/components/select-input';
import { CardSection } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

export function SenderFormCard() {
  const { t } = useTranslation();

  return (
    <HalfContainer>
      <CardSection>
        <Text variant="HeadingXSmall">{t('common:from')}</Text>
        <SeparatorVertical $margin={16} />
        <FullContainer>
          <Input
            type="select"
            name="fromAccountType"
            options={[
              {
                id: AccountTypeEnum.bank,
                label: t(`common:${AccountTypeEnum.bank}`),
              },
              {
                id: AccountTypeEnum.cash,
                label: t(`common:${AccountTypeEnum.cash}`),
              },
            ]}
            required
            hideRequiredStar
            label={t('common:type')}
            placeholder={t('common:type')}
          />
        </FullContainer>
        <FullContainer>
          <HOCInput keys={['fromAccountType']}>
            {(values) => {
              switch (values.fromAccountType) {
                case AccountTypeEnum.bank:
                  return (
                    <BankAccountSelectInput name="fromAccountable" required />
                  );
                case AccountTypeEnum.cash:
                  return (
                    <CashAccountSelectInput name="fromAccountable" required />
                  );
                default:
                  return <></>;
              }
            }}
          </HOCInput>
        </FullContainer>
      </CardSection>
    </HalfContainer>
  );
}
